import { Text } from "@chakra-ui/react";
import React from "react";

const DeleteAcc = () => {

    return (
        <Text>Delete Account</Text>
    )
}
export default DeleteAcc